/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Image_Subtitles_AriaInputs */

const en_file_export_image_subtitles_aria = /** @type {(inputs: File_Export_Image_Subtitles_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export image-based subtitles`)
};

const fr_file_export_image_subtitles_aria = /** @type {(inputs: File_Export_Image_Subtitles_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter des sous-titres en images`)
};

const de_file_export_image_subtitles_aria = /** @type {(inputs: File_Export_Image_Subtitles_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportieren von bildbasierten Untertiteln`)
};

const it_file_export_image_subtitles_aria = /** @type {(inputs: File_Export_Image_Subtitles_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta sottotitoli basati su immagini`)
};

const ru_file_export_image_subtitles_aria = /** @type {(inputs: File_Export_Image_Subtitles_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт субтитров на основе изображений`)
};

const es_file_export_image_subtitles_aria = /** @type {(inputs: File_Export_Image_Subtitles_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar subtítulos basados en imágenes`)
};

const zh_cn2_file_export_image_subtitles_aria = /** @type {(inputs: File_Export_Image_Subtitles_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出基于图像的字幕`)
};

const ja_file_export_image_subtitles_aria = /** @type {(inputs: File_Export_Image_Subtitles_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像ベースの字幕をエクスポートする`)
};

const hi_file_export_image_subtitles_aria = /** @type {(inputs: File_Export_Image_Subtitles_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छवि-आधारित उपशीर्षक निर्यात करें`)
};

const pt_pt2_file_export_image_subtitles_aria = /** @type {(inputs: File_Export_Image_Subtitles_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar legendas baseadas em imagens`)
};

/**
* | output |
* | --- |
* | "Export image-based subtitles" |
*
* @param {File_Export_Image_Subtitles_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_image_subtitles_aria = /** @type {((inputs?: File_Export_Image_Subtitles_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Image_Subtitles_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_image_subtitles_aria(inputs)
	if (locale === "de") return de_file_export_image_subtitles_aria(inputs)
	if (locale === "it") return it_file_export_image_subtitles_aria(inputs)
	if (locale === "ru") return ru_file_export_image_subtitles_aria(inputs)
	if (locale === "es") return es_file_export_image_subtitles_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_image_subtitles_aria(inputs)
	if (locale === "ja") return ja_file_export_image_subtitles_aria(inputs)
	if (locale === "hi") return hi_file_export_image_subtitles_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_image_subtitles_aria(inputs)
	return en_file_export_image_subtitles_aria(inputs)
});